import { Download } from "components/icons/generated";
import Button, { ButtonProps } from "ds/components/Button";

import useExportTraces from "./useExportTraces";

type ExportTracesButtonProps = {
  size?: ButtonProps["size"];
};

const ExportTracesButton = ({ size = "medium" }: ExportTracesButtonProps) => {
  const { hasTraces, label, openDrawer } = useExportTraces();

  if (!hasTraces) {
    return null;
  }

  return (
    <Button variant="secondary" startIcon={Download} size={size} onPress={openDrawer}>
      {label}
    </Button>
  );
};

export default ExportTracesButton;
